<template>
  <div>

    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

<!--___________Form_____________ -->
    <v-card>
      <!-- {{formSchema}}  -->
    <!-- Confirmation box -->
    <v-layout row justify-center>
      <v-dialog v-model="confirmDialog" max-width="700">
        <v-card>
          <v-card-title>
            <span class="headline">Are you sure you want to {{buttonTitle}} this data?</span>
          </v-card-title>
          <hr>
          <v-card-text>
            <table class="modal-td">            
              <!--  
              <tr>
                <td>Voucher Number</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{formSchema.voucher_number}}</td>
              </tr> 
              -->
              <tr>
                <td style="width: 156px;">Sub-Project Name</td>
                <td>:</td>
                <td>{{formSchema.client_name}}</td>
              </tr>
              <tr>
                <td style="width: 156px;">PFI Name</td>
                <td>:</td>
                <td>{{formSchema.short_name}}</td>
              </tr>
              <tr>
                <td style="width: 156px;">Loan Number</td>
                <td>:</td>
                <td>{{formSchema.loan_no}}</td>
              </tr>
              <tr>
                <td>Loan Amount</td>
                <td>:</td>
                <td>{{formSchema.loan_amount}}</td>
              </tr>  
              <tr>
                <td style="width: 156px;">Disbursement Date</td>
                <td>:</td>
                <td>{{formSchema.disbursement_date}}</td>
              </tr>                        
              <tr>
                <td>Disbursement Account</td>
                <td>:</td>
                <td>{{formSchema.disbursement_account}}</td>
              </tr>
              <tr>
                <td>Currency</td>
                <td>:</td>
                <td>{{formSchema.transaction_currency}}</td>
              </tr>
              <tr>
                <td>USD Rate</td>
                <td>:</td>
                <td>{{formSchema.currency_rate}}</td>
              </tr>
              <tr>
                <td>Available Amount</td>
                <td>:</td>
                <td>{{formSchema.available_amount}}</td>
              </tr>
              <tr>
                <td>Today Disbursement</td>
                <td>:</td>
                <td>{{formSchema.today_disbursement}}</td>
              </tr>
              <tr>
                <td>Equivalent {{ (formSchema.transaction_currency == 'BDT' ? 'USD' : 'BDT')}} Amount</td>
                <td>:</td>
                <td>{{ (formSchema.transaction_currency == 'BDT' ? credit.usd_credit : credit.bdt_credit)}}</td>
              </tr>
            </table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="confirmDialog = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.once="submitForm"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation box -->

      <v-card-title class="pb-0">
        <span class="headline">{{buttonTitle}} Disbursement</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation class="mt-0">
        <v-card-text>
          <v-container grid-list-md class="py-0">
            <v-layout wrap>

              <v-flex xs12 sm6 md4>
                <DatePicker
                  :key="formSchema.id"
                  :rules="[v => !!v || 'Date is required !']"
                  :inputData="{index:1,fieldName:'disbursement_date', fieldValue:formSchema.disbursement_date, label:'Disbursement Date *', required:'1',minVal:changeFormateDMY(formSchema.loan_date)}"
                  @setValue="setDateValue"
                ></DatePicker>
                </v-flex>          

                <v-flex xs12 sm6 md4>
                  <!-- <input type="hidden" v-model="formSchema.loan_id" :valure="formSchema.loan_id">
                  <input type="hidden" v-model="formSchema.voucher_number" :valure="formSchema.voucher_number"> -->

                  <v-text-field
                  label="Loan Number *"
                  v-model="formSchema.loan_no"
                  :rules="[v => !!v || 'Loan no is required !']"
                  required
                  readonly
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <v-text-field
                  label="Loan Amount *"
                  v-model="formSchema.loan_amount"
                  :rules="[v => !!v || 'Loan amount no is required !']"
                  required
                  readonly
                  ></v-text-field>
                </v-flex>
                   <v-flex xs12 sm6 md4>
                  <v-select
                  label="Currency *"
                  v-model="formSchema.transaction_currency"
                  :items="['BDT','USD']" 
                  :rules="[v => !!v || 'Currency is required !']"
                  required
                  readonly
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-autocomplete
                  label="Source of Fund *"
                  v-model="formSchema.fund_source"
                  :items="['IDA','GoB']" 
                  :rules="[v => !!v || 'Source of fund is required !']"
                  required
                  @input="setVoucherData"
                  >
                  </v-autocomplete>
                </v-flex>
                 <v-flex xs12 sm6 md4>
                  <v-text-field
                  label="USD Rate *"
                  v-model="formSchema.currency_rate"  
                  :rules="[v => !!v || 'USD rate is required !', lng11]"
                  required     
                  @input="setVoucherData"          
                  ></v-text-field>
                </v-flex>     
                <v-flex xs12 sm6 md4>                  
                <v-autocomplete
                  label="Disbursement Account *"
                  item-text="eco_account_name"
                  item-value="eco_account_code"
                  v-model="formSchema.disbursement_account"
                  :items="DisbursementAccountList" 
                  :rules="[v => !!v || 'Disbursement account id is required !']"
                  required
                  @input="changeDisbursementAmt(formSchema.disbursement_account)"
                  >
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <v-autocomplete
                    label="Economic code *"
                    item-text="eco_account_code"
                    item-value="id"
                    v-model="formSchema.economic_code_id"
                    :items="EcoCodeInfoList" 
                    :rules="[v => !!v || 'Economic code id is required !']"
                    required
                    @input="changeEcoCode(formSchema.economic_code_id)"
                    >
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm6 md4 v-show="false"> 
                  <v-text-field
                  label="Available Amount *"
                  v-model="formSchema.available_amount"  
                  readonly
                  ></v-text-field>
                </v-flex>

             
               
                <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Disbursement Amount"
                  v-model="formSchema.disbursement_amount"                  
                  readonly
                  @input="setVoucherData"
                ></v-text-field>
                </v-flex>

                          

                <!-- <v-flex xs12 sm6 md4>                  
                  <v-text-field
                  label="Today Disbursement"
                  v-model="formSchema.today_disbursement"  
                  :rules="[v => !!v || 'Today disbursement is required !',decimal]"
                  required                
                  @input="changeAmount(formSchema.today_disbursement)"  
                  ></v-text-field>
                </v-flex>  --> 
                <input type="hidden" v-model="formSchema.today_disbursement">


                <!-- <v-flex xs12 sm6 md4 style="position:relative">
                  <v-text-field
                  style="width:75%; display: inline-block;"
                  label="Credit A"
                  :rules="[v => !!v || 'USD rate is required !', decimal]"                
                  v-model="formSchema.credit_a"
                  @keyup="changeLoanAmount('credit_a')"
                  @input="changeLoanAmount('credit_a')"
                  type="number"
                  ></v-text-field>
                  <input type="number" v-model="formSchema.credit_a_percent" style="border:1px solid #ccc; width:18%; display: inline-block;">%
                </v-flex>

                <v-flex xs12 sm6 md4 style="position:relative">
                  <v-text-field
                  style="width:75%; display: inline-block;"
                  label="Credit B"
                  v-model="formSchema.credit_b"
                  :rules="[v => !!v || 'USD rate is required !', decimal]"
                  @keyup="changeLoanAmount('credit_b')"  
                  @input="changeLoanAmount('credit_b')"    
                  type="number"
                  ></v-text-field>
                  <input type="number" v-model="formSchema.credit_b_percent" style="border:1px solid #ccc; width:18%; display: inline-block;">%
                </v-flex> -->

                <v-flex xs12 sm6 md4 v-if="formSchema.fund_source == 'IDA'">
                  <v-text-field
                  label="Credit A(%)"
                  v-model="formSchema.credit_a"  
                  :rules="[v => !!v || 'Credit a is required !', decimal]"
                  required     
                  @input="calculateCredit('credit_a', 'credit_b')"                  
                  ></v-text-field>
                </v-flex> 

                <v-flex xs12 sm6 md4 v-if="formSchema.fund_source == 'IDA'">
                  <v-text-field
                  label="Credit B(%)"
                  v-model="formSchema.credit_b"  
                  :rules="[v => !!v || 'Credit b is required !', decimal]"
                  required     
                   @input="calculateCredit('credit_b', 'credit_a')"
                   readonly
                  ></v-text-field>
                </v-flex> 

              </v-layout>              

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" v-if="saveBtn" @click.native="confirmation" :disabled="!valid">
                  <v-icon>save</v-icon>
                  {{buttonTitle}}
                </v-btn>
                <v-btn color="error" @click="previous">
                  <v-icon>arrow_back_ios</v-icon>Previous
                </v-btn>
              </v-card-actions>

            </v-container>
          </v-card-text>
      </v-form>
    </v-card>
    <!-- _____________/Form_____________ -->


    <template>
      <v-card>
        <table class="paySchedule">
          <tbody>        
            <tr class="tb-td">
              <th>Economic Code</th>
              <th style="padding:0px;">Economic Name</th>
              <th v-if="show">TR Debit</th>
              <th v-if="show">TR Credit</th>
              <th>Currency</th>
              <th>BDT Debit</th>
              <th>BDT Credit</th>
               <th>USD Debit</th>
               <th>USD Credit</th>
              <th>Src Fund</th>             
              <th>Cr. Name</th>             
              <th>Loan no</th>
            </tr>
            <!-- __________________ Debit Row _________________ -->
            <tr>
              <td class="textCenter">
                <input type="text" v-model="debit.eco_code" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="debit.account_name" readonly>
              </td>         
              <td v-if="show" class="textCenter">
                <input type="text" v-model="debit.tr_debit" readonly>
              </td>          
              <td v-if="show" class="textCenter">
                <input type="text" v-model="debit.tr_credit" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="debit.currency" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="debit.bdt_debit" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="debit.bdt_credit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="debit.usd_debit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="debit.usd_credit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="debit.src_fund" readonly>
              </td> 
              <td class="textCenter">
                <input type="text" v-model="debit.cr_name" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="debit.loan_no" readonly>
              </td>          
            </tr>
            <!-- __________________ /Debit Row _________________ -->


            <!-- __________________ Debit Row _________________ -->
            <tr v-if="formSchema.fund_source == 'IDA'">
              <td class="textCenter">
                <input type="text" v-model="creditB.eco_code" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="creditB.account_name" readonly>
              </td>         
              <td v-if="show" class="textCenter">
                <input type="text" v-model="creditB.tr_debit" readonly>
              </td>          
              <td v-if="show" class="textCenter">
                <input type="text" v-model="creditB.tr_credit" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="creditB.currency" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="creditB.bdt_debit" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="creditB.bdt_credit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="creditB.usd_debit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="creditB.usd_credit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="creditB.src_fund" readonly>
              </td> 
              <td class="textCenter">
                <input type="text" v-model="creditB.cr_name" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="creditB.loan_no" readonly>
              </td>          
            </tr>
            <!-- __________________ /Debit Row _________________ -->


            <!-- __________________ Credit Row_________________ -->
            <tr>
              <td class="textCenter">
                <input type="text" v-model="credit.eco_code" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="credit.account_name" readonly>
              </td>         
              <td v-if="show" class="textCenter">
                <input type="text" v-model="credit.tr_debit" readonly>
              </td>          
              <td v-if="show" class="textCenter">
                <input type="text" v-model="credit.tr_credit" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="credit.currency" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="credit.bdt_debit" readonly>
              </td>         
              <td class="textCenter">
                <input type="text" v-model="credit.bdt_credit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="credit.usd_debit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="credit.usd_credit" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="credit.src_fund" readonly>
              </td>
              <td class="textCenter">
                <input type="text" v-model="credit.cr_name" readonly>
              </td>          
              <td class="textCenter">
                <input type="text" v-model="credit.loan_no" readonly>
              </td>          
            </tr>
            <!-- __________________ /Credit Row _________________ -->           
            
          </tbody>
        </table>
      </v-card>
    </template>

  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import DatePicker from "../../global/date_picker";

import Axios from "axios";

export default {
  components: {
   DatePicker 
  },

  data: () => ({
    valid: true,
    saveBtn:true,
    show:false,
    buttonTitle:'Save',

    leaveTypeModal: false,
    detailObject:'',
    confirmDialog:false,
    EcoCodeInfoList:[],
    DisbursementAccountList:[],

    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: ""
    },

    formSchema:{
      disbursement_date:'',
      loan_id:'',
      loan_no:'',
      loan_amount:'',
      disbursement_account:'',
      economic_code_id:'',
      available_amount:'',
      transaction_currency:'',
      fund_source:'GoB',
      disbursement_amount:'',
      currency_rate:'',
      today_disbursement:'',
      re_schedule_no:'',
      credit_a:1,
      credit_b:2,
    },

    debit:
    {          
      eco_code_id:'',
      eco_code:'',
      account_name:'',
      tr_debit:'',
      tr_credit:'',
      currency:'',
      bdt_debit:'',
      bdt_credit:'',
      usd_debit:'',
      usd_credit:'',
      src_fund: '',
      loan_no:'',
      amount_type:"Ins",
    },

    creditB:
    {          
      eco_code_id:'',
      eco_code:'',
      account_name:'',
      tr_debit:'',
      tr_credit:'',
      currency:'',
      bdt_debit:'',
      bdt_credit:'',
      usd_debit:'',
      usd_credit:'',
      src_fund: '',
      loan_no:'',
      amount_type:"Ins",
    },

    credit:
    {
      eco_code_id:'',
      eco_code:'',
      account_name:'',
      tr_debit:'',
      tr_credit:'',
      currency:'',
      bdt_debit:'',
      bdt_credit:'',
      usd_debit:'',
      usd_credit:'',
      src_fund: '',
      loan_no:'',
      amount_type:"D",
    },
    
  }),

  created(){  
    commonService.getAllData("get-dis-dropdown-data-dis").then(res => {        
        this.EcoCodeInfoList = res.EcoCodeInfoList;

        // Existing data
          let info = this.$store.getters.GET_SEARCH_DISBURSEMENT_DATA;
            console.log('info=========', info);     
          if(info)
          { 
            this.DisbursementAccountList = info.disbursement_accountInfo;
            //this.DisbursementAccountList.push(info.disbursement_accountInfo);
            this.formSchema = info;

            // if partial Gace loan
            if(this.formSchema.partial_next_date){
              this.formSchema.disbursement_date = this.changeFormateDMY(info.partial_next_date);
              this.formSchema.loan_amount = (parseFloat(info.loan_amount) - parseFloat(info.partial_amount));
              this.formSchema.disbursement_amount =  this.formSchema.loan_amount;
            }

          if(info.is_edit){
            this.formSchema.disbursement_date = this.changeFormateDMY(info.disbursement_date);
            this.formSchema.loan_amount = info.disbursement_amount;
            this.formSchema.today_disbursement = info.disbursement_amount;
            this.formSchema.transaction_currency = info.currency_code;
            this.formSchema.currency_rate = info.currency_rate;
            this.formSchema.disbursement_account = info.disbursement_accountInfo[0].eco_account_code;
            this.setVoucherData();
            this.changeDisbursementAmt(info.disbursement_accountInfo[0].eco_account_code);
            this.changeEcoCode(info.economic_code_id);
            this.buttonTitle = 'Update';
          }

          if(info.available_amount < 1)
          {
            this.saveBtn = false;
            this.SnackbarVal.message = 'Available amount is empty';
            this.SnackbarVal.snackbar = true;
            this.SnackbarVal.color = "error"
          }

          let disAmount = (info.disbursement_amount > 0) ? info.disbursement_amount : 0 
          this.formSchema.today_disbursement = (info.loan_amount - disAmount);
        }

        

        if(!this.formSchema.loan_id)
        {
          this.$router.push("/on-lending/search-disbursement");
        }

    });

    
  },

  mounted() {
      

  },

  methods: {

    submitForm() {
      let root = this

      var formSchema = this.formSchema; 

      formSchema.currency = formSchema.transaction_currency

      formSchema.disbursement_date = this.changeFormateYMD(formSchema.disbursement_date);
      
      let formData = new FormData();

      formData.append("formSchema", JSON.stringify(this.formSchema));
      formData.append("debit", JSON.stringify(this.debit));
      
      formData.append("creditB", []);
      if(formSchema.fund_source == 'IDA'){
        formData.append("creditB", JSON.stringify(this.creditB));
      }

      formData.append("credit", JSON.stringify(this.credit));

        commonService
          .insertFormData(formData, "loan-disbursement")
          .then(res => {

            if(res.status == 1)
            {       
              this.saveBtn = false;       
              this.SnackbarVal.color = "success"
              this.$store.commit('UNSET_SEARCH_DISBURSEMENT_DATA');
              this.confirmDialog = false;
            }
            else
            {
              this.SnackbarVal.color = "error"
            }
            this.SnackbarVal.message = res.message;
            this.SnackbarVal.snackbar = true;

            setTimeout(function() {
              root.$router.push("/on-lending/search-disbursement");       
            }, 3000);

          });
    },

    confirmation() {
      let formSchema = this.formSchema
      this.changeAmount(formSchema.today_disbursement);

      if (this.$refs.form.validate()) {         
        this.confirmDialog = true;                    
      }
    },

    changeDisbursementAmt(val){

      if(val)
      {
        let dis = this.DisbursementAccountList.filter(function(a){
          return a.eco_account_code == val
        })[0];

        let credit = this.credit    
        credit.eco_code_id = dis.id
        credit.eco_code = dis.eco_account_code
        credit.account_name = dis.eco_account_name;
        var eID = credit.eco_code_id;
      }
      //alert(eID);
      // Item Amount Validation
      if(!!eID) {  
        this.amountValidation(eID); 
      }
    },

     /* {{this.EcoCodeInfoList}}*/
    changeEcoCode(val)
    {         
      let eco = this.EcoCodeInfoList.filter(function(a){
        return a.id === val
      })[0];
      if(!!eco)
      {
        let debit = this.debit;
        debit.eco_code_id = eco.id
        debit.eco_code = eco.economic_code
        debit.account_name = eco.eco_account_name

        let creditB = this.creditB;
        creditB.eco_code_id = eco.id
        creditB.eco_code = eco.economic_code
        creditB.account_name = eco.eco_account_name
        var eID = creditB.eco_code_id;
      }
      // Item Amount Validation
      if(!!eID) {  
        this.amountValidation(eID); 
      }

    },


    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
    },

    previous(){
      this.$store.commit('UNSET_SEARCH_DISBURSEMENT_DATA');
      this.$router.push("/on-lending/search-disbursement");   
    },

    changeAmount(todayDisbursementAmount){
      let formSchema = this.formSchema
      let available_amount = Number(formSchema.available_amount);
      let todayPayAmount = Number(todayDisbursementAmount);

      if(available_amount < todayPayAmount)
      {
        this.saveBtn = false
        formSchema.today_disbursement = "";

        this.SnackbarVal.message = 'Today disbursement amount will be less than or equal of available amount';
        this.SnackbarVal.snackbar = true;
        this.SnackbarVal.color = "error"
        return 0;
      }
      else
      {
        this.saveBtn = true
      }
      this.setVoucherData();
    },

    numberFormate(numBer)
    {
      if(numBer != '-')
      {
        //return Number(numBer).toFixed(4);
        return Math.round(numBer);
        //return Math.round(numBer).toLocaleString()+'.00';
      }
      else
      {
       return '0.00'; 
      }
    },

    calculateCredit(field1, field2){
      var formSchema = this.formSchema

      if(parseFloat(formSchema[field1]) > 100)
      {
        this.SnackbarVal.message = 'Enter less then or equal to 100';
        this.SnackbarVal.snackbar = true;
        this.SnackbarVal.color = "error";
        formSchema.credit_a = 0
        formSchema.credit_b = 0
        return 0
      }
      
      if(formSchema.fund_source == 'IDA')
      {
        if(field1 == 'credit_a')
        {
          let val = (100 - (parseFloat(formSchema[field1])||0));
          formSchema.credit_b = (val > 0) ? val : '0'
          this.debit.tr_debit = (formSchema.loan_amount*val)/100;
          this.setVoucherData();
        }

        if(field1 == 'credit_b')
        {
          let val = (100 - (parseFloat(formSchema[field1])||0));
          formSchema.credit_a = (val > 0) ? val : '0'
          this.debit.tr_debit = (formSchema.loan_amount*val)/100;
          this.setVoucherData();
        }
      }
      /*else
      {
       let val = 0
       formSchema.credit_a = 0;
       formSchema.credit_b = 0;
       this.debit.tr_debit = (formSchema.loan_amount*val)/100;
       this.setVoucherData();
      }*/

      

    },

    /*
    changeLoanAmount(forVal) {
      let formSchema = this.formSchema;

      let loanAmount = parseFloat(formSchema.loan_amount);
      let creditA = parseFloat(formSchema.credit_a);
      let creditB = parseFloat(formSchema.credit_b);

      if (loanAmount < 1) {
        this.SnackbarVal.message = 'Loan amount is empty!';
        this.SnackbarVal.snackbar = true;
        this.SnackbarVal.color = "error";
        formSchema.credit_a = '';
        formSchema.credit_b = '';
        formSchema.credit_a_percent = 0
        formSchema.credit_b_percent = 0
        return 0
      }

      if((creditA > loanAmount) || (creditB > loanAmount))
      {
        this.SnackbarVal.message = 'Cross your loan amount!';
        this.SnackbarVal.snackbar = true;
        this.SnackbarVal.color = "error";
        formSchema.credit_a = '';
        formSchema.credit_b = '';
        formSchema.credit_a_percent = 0
        formSchema.credit_b_percent = 0
        return 0
      }

      if (forVal == "credit_a") {
        formSchema.credit_b = (loanAmount - creditA);        
      }
      if (forVal == "credit_b") {
        formSchema.credit_a = (loanAmount - creditB);        
      }

      formSchema.credit_a_percent = ((formSchema.credit_a * 100) / loanAmount).toFixed(2);
      formSchema.credit_b_percent = ((formSchema.credit_b * 100) / loanAmount).toFixed(2);
    },
    */
    setVoucherData(){

    let formSchema = this.formSchema;
    let debit = this.debit;
    let credit = this.credit;
    let creditB = this.creditB;
    
    this.changeEcoCode(formSchema.economic_code_id);
    this.changeDisbursementAmt(formSchema.disbursement_account);

    if(formSchema.fund_source == 'GoB')
    {
       formSchema.credit_a = 0;
       formSchema.credit_b = 0;
    }


    if(formSchema.transaction_currency == 'USD')
    {
      
      let cr_a = (formSchema.loan_amount * (parseFloat(formSchema.credit_a)||0)) / 100;
      if(formSchema.fund_source == 'GoB'){
        cr_a = formSchema.loan_amount;
      }  

      debit.tr_debit = cr_a;
      //debit.tr_debit = formSchema.today_disbursement
      debit.tr_credit = 0
      debit.currency = formSchema.transaction_currency
      debit.bdt_debit = this.numberFormate(cr_a * formSchema.currency_rate)
      //debit.bdt_debit = this.numberFormate(formSchema.today_disbursement * formSchema.currency_rate)
      debit.bdt_credit = 0
      debit.usd_debit = cr_a
      //debit.usd_debit = formSchema.today_disbursement;      
      debit.usd_credit = 0
      debit.src_fund = formSchema.fund_source
      debit.cr_name = 'Credit A';
      debit.loan_no = formSchema.loan_no;

      
      var cr_b = (formSchema.loan_amount * (parseFloat(formSchema.credit_b)||0)) / 100;
      creditB.tr_debit = cr_b;
      //creditB.tr_debit = formSchema.today_disbursement
      creditB.tr_credit = 0
      creditB.currency = formSchema.transaction_currency
      creditB.bdt_debit = this.numberFormate(cr_b * formSchema.currency_rate)
      //creditB.bdt_debit = this.numberFormate(formSchema.today_disbursement * formSchema.currency_rate)
      creditB.bdt_credit = 0
      creditB.usd_debit = cr_b
      //creditB.usd_debit = formSchema.today_disbursement;      
      creditB.usd_credit = 0
      creditB.src_fund = formSchema.fund_source
      creditB.cr_name = 'Credit B';
      creditB.loan_no = formSchema.loan_no


      credit.tr_debit = 0
      credit.tr_credit = formSchema.loan_amount
      credit.currency = formSchema.transaction_currency
      credit.bdt_debit = 0
      credit.bdt_credit = this.numberFormate(formSchema.loan_amount * formSchema.currency_rate)
      credit.usd_debit = 0
      credit.usd_credit = formSchema.loan_amount
      credit.src_fund = formSchema.fund_source
      credit.cr_name = '-';
      credit.loan_no = formSchema.loan_no
    }
    else
    { 
      let cr_a = (formSchema.loan_amount * (parseFloat(formSchema.credit_a)||0)) / 100;
      if(formSchema.fund_source == 'GoB'){
        cr_a = formSchema.loan_amount;
      }  
      //debit.tr_debit = formSchema.loan_amount
      debit.tr_debit = cr_a;
      debit.tr_credit = 0
      debit.currency = formSchema.transaction_currency
      debit.bdt_debit = cr_a
      //debit.bdt_debit = formSchema.loan_amount
      debit.bdt_credit = 0
      debit.usd_debit = this.numberFormate(cr_a / formSchema.currency_rate)
      //debit.usd_debit = this.numberFormate(formSchema.loan_amount / formSchema.currency_rate)
      debit.usd_credit = 0
      debit.src_fund = formSchema.fund_source
      debit.cr_name = 'Credit A';
      debit.loan_no = formSchema.loan_no


      let cr_b = (formSchema.loan_amount * (parseFloat(formSchema.credit_b)||0)) / 100;

      //creditB.tr_debit = formSchema.loan_amount
      creditB.tr_debit = cr_b;
      creditB.tr_credit = 0
      creditB.currency = formSchema.transaction_currency
      creditB.bdt_debit = cr_b
      //creditB.bdt_debit = formSchema.loan_amount
      creditB.bdt_credit = 0
      creditB.usd_debit = this.numberFormate(cr_b / formSchema.currency_rate)
      //creditB.usd_debit = this.numberFormate(formSchema.loan_amount / formSchema.currency_rate)
      creditB.usd_credit = 0
      creditB.src_fund = formSchema.fund_source
      creditB.cr_name = 'Credit B';
      creditB.loan_no = formSchema.loan_no


      credit.tr_debit = 0
      credit.tr_credit = formSchema.loan_amount
      credit.currency = formSchema.transaction_currency
      credit.bdt_debit = 0
      credit.bdt_credit = formSchema.loan_amount
      credit.usd_debit = 0
      credit.usd_credit = this.numberFormate(formSchema.loan_amount / formSchema.currency_rate)
      credit.src_fund = formSchema.fund_source
      credit.cr_name = '-';
      credit.loan_no = formSchema.loan_no
    }

    },


    amountValidation(eID){
      // Item Amount Validation
      var date = this.changeFormateYMD( this.formSchema.disbursement_date);
      var source = this.formSchema.fund_source;
      var currency = this.formSchema.transaction_currency;
      var rate = this.formSchema.currency_rate;
      let arrData = {date:date,source:source,id:eID,currency:currency,rate:rate};
      commonService.dataByMulParameters(arrData, "get_amount_by_eco").then(res => {
        var available = this.formSchema.available_amount;
        var maxAm = res.amount;
        if(maxAm < available){
          this.saveBtn = false;
          this.SnackbarVal.message = 'Disbursement amount will be less than or equal of '+ maxAm + ' amount';
          this.SnackbarVal.snackbar = true;
          this.SnackbarVal.color = "error";
          return 0;
        }else{
          this.saveBtn = true;
        }
      });
    },


   
  },

  computed:{
  }
};
</script>

<style scoped>
table.paySchedule{
  width:100%;
  border-collapse: collapse;
}
.paySchedule th{
  border: 1px solid #CCC;
  text-align: center;
  text-align: center;
}
.paySchedule td{
  border: 1px solid #CCC;
  line-height: 41px;
  text-align: center;
  text-align: center;
}
.paySchedule tr.tb-td td{
  font-weight: bold;
}
td.textCenter{
  text-align: center;
}
td.textRight{
  text-align: right;
}
td input{
  width:100%;
  text-align: center;
}
table.modal-td td{
  padding-right: 4px !important;
  text-align: justify;
}
</style>


// WEBPACK FOOTER //
// src/components/lending/disbursement/insert_form.vue